module.exports = __webpack_public_path__ + "img/menunggu.2d9eb6c3.png";